$(document).ready(function(){

    $('.js-scrollTo').click(function() {
        scrollTo( $($(this).attr('data-target')), $(this).attr('data-tab')  );
    })

    $('.js-menu-scroll').click(function(){
        scrollTo( $($('a', this).attr('href')) );
        mobile_menu_close(1);
    })

    $(window).scroll(function() {
        scrollTop = $(window).scrollTop();

        if (scrollTop > 500) {
            $('.toTop').addClass('show');
        }
        else {
            $('.toTop').removeClass('show');
        }
    });
})

function scrollTo(target, tab = false, offset = 100, scroll_speed = 800){
    if(tab){
        $('.tabs-nav li[data-tab="'+tab+'"').click();
    }

    if( target.length ) {
        $('html, body').stop().animate({
            scrollTop: target.offset().top-offset
        }, scroll_speed);
    }
}
